import absoluteUrl from 'next-absolute-url'

import ArticleCategory from 'containers/ArticleCategory'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { masterDataService, defaultParams } from 'services'

export default function Index({ canonical, articles, slug, articleType }) {
  const metaTitle = articles?.[0]?.title
  const metaDescription = articles?.[0]?.shortDescription
  const metaImage = articles?.[0]?.thumbnailImage?.[0]?.url
  const publishedTime = articles?.[0]?.createdAt
  const modifiedTime = articles?.[0]?.updatedAt

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        image={metaImage}
        ogType="article"
        publishedTime={publishedTime}
        modifiedTime={modifiedTime}
        section={metaTitle}
        pathUrl={canonical}
      />

      <Layout>
        <ArticleCategory articles={articles} slug={slug} articleType={articleType} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req, res, query } = context
  const { origin } = absoluteUrl(req)
  const { slug } = query

  res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59')

  const [articles, articleType] = await Promise.all([
    masterDataService({
      method: 'post',
      url: '/article/query',
      data: {
        where: [
          {
            ...defaultParams,
            articleTypes: {
              code: {
                $in: [slug],
              },
            },
          },
        ],
        relations: ['articleTypes'],
      },
    }).then(res => res.data.data),
    masterDataService({
      method: 'post',
      url: '/articleType/query',
      data: {
        where: [
          {
            ...defaultParams,
            code: slug,
          },
        ],
        limit: 1,
      },
    }).then(res => res.data.data?.[0]),
  ])

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/blog/${slug}`,
        articles,
        articleType,
        slug,
      })
    ),
  }
}
